import fileDownload from "js-file-download";
import React, { useState } from "react";
import { useDataProvider, useNotify } from "react-admin";
import { StyledButton } from "../../../components/ListShowButton";

interface IDownloadExcelButton {
  purchaseInvoiceSummaryId: number;
  period: string;
  disabled?: boolean;
}

const DownloadExcelButton = ({
  purchaseInvoiceSummaryId,
  period,
  disabled = false,
}: IDownloadExcelButton) => {
  const provider = useDataProvider();
  const notify = useNotify();
  const [isLoading, setLoading] = useState(false);

  const getExcelFile = () => {
    if (disabled || isLoading ) return; // prevent triggering if disabled / multiple clicks

    setLoading(true);

    provider
      .downloadFile(
        `subcontractorPurchaseInvoiceSummaries/${purchaseInvoiceSummaryId}/download`
      )
      .then(({ data }: any) => {
        if (data) {
          fileDownload(
            data,
            `purchase-invoice-summary-${purchaseInvoiceSummaryId}-${period}.xlsx`
          );
        } else {
          notify("The Excel doesn't exist.", "warning");
        }
      })
      .catch((error: any) => {
        notify(`Error : ${error.message}`, "error");
      })
      .finally(() => {
        setLoading(false);
      });
  };

  return (
    <StyledButton 
      variant="outlined" 
      onClick={getExcelFile} 
      disabled={disabled || isLoading}
    >
      {isLoading ? "Downloading..." : `Download Purchase Invoice Summaries`}
    </StyledButton>
  );
};

export default DownloadExcelButton;
